import { Log } from '@lightningjs/sdk';
import { AdultType, CardType, ExtraDataType, SortBy, SortDir } from '../../api/models/Shared.types';
import { CmsRibbon } from '../../components/cms/CmsRibbon';
import { CardDataSource } from './CardDataSource';
import { CardSizeInfo } from './CardSizeInfo';
import { Environment } from '../../config/environment';
import { LLDataSource } from './LLDataSource';
import { Backend } from '../../api/Backend';
import { VodApi } from '../../api/VodApi';

const _constants = {
  firstLoadAmount: 6,
  loadAmount: 3,
};

export class EpisodeRibbonDataSource extends LLDataSource {
  private seasonId: string;
  private properties: string[];
  private allowAdult: AdultType;
  private sortBy: SortBy;
  private sortDir: SortDir;
  private cardType: CardType;
  public sizeInfo: CardSizeInfo;
  private title: string | undefined;

  constructor(
    backend: Backend,
    seasonId: string,
    properties: string[],
    allowedAdultMode = AdultType.False,
    sortBy = SortBy.episode,
    sortDir = SortDir.Asc,
    cardType = CardType.Landscape
  ) {
    super(backend, _constants.firstLoadAmount, _constants.loadAmount);
    this.seasonId = seasonId;
    this.properties = properties;
    this.allowAdult = allowedAdultMode;
    this.sortBy = sortBy;
    this.sortDir = sortDir;
    this.cardType = cardType;

    this.hasNextPage = true;
    this.sizeInfo = new CardSizeInfo();

    this.title = undefined; //episodeRibbons never have a title (tabs button)
  }

  _fetchPage(page: number): Promise<EpisodeRibbonDataSource | undefined> {
    return VodApi.episodes(this.backend, this.seasonId, {
      page: `${page}`,
      platformType: Environment.system,
      catalogId: this.backend.deviceProfile?.profile.catalog,
      adult: this.allowAdult,
      sortBy: this.sortBy,
      sortDir: this.sortDir,
      extraData: ExtraDataType.MINI,
    })
      .then(result => {
        if (!result) return undefined;
        this.sizeInfo.updateWithContainer(result, this.properties);
        this.hasNextPage = result.nextPage ? result.nextPage : false;
        const newCards = result.items?.map(
          card => new CardDataSource(this.backend, card, this.sizeInfo, this.properties)
        );
        if (newCards) this.items = this.items.concat(newCards);
        return this as EpisodeRibbonDataSource;
      })
      .catch(err => {
        Log.error(`Error fetching episodeRibbon ${this.seasonId}: ${err}`);
        return this;
      });
  }

  totalHeight() {
    return this.sizeInfo.height;
  }

  set initialSizeInfo(szi: CardSizeInfo) {
    this.sizeInfo = szi;
  }

  override componentDescription() {
    return {
      focusable: true,
      type: CmsRibbon,
      data: this,
      h: this.totalHeight(),
    };
  }
}
